import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { fetchGetGallery } from "./asyncActions";
import { IGalleryCategory, IGalleryState } from "./types";

const initialState: IGalleryState = {
  isLoading: false,
  gallery: [],
};

const gallerySlice = createSlice({
  name: "gallery",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchGetGallery.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchGetGallery.fulfilled, (state, action: PayloadAction<IGalleryCategory[]>) => {
      state.gallery = action.payload;
      state.isLoading = false;
    });
    builder.addCase(fetchGetGallery.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default gallerySlice.reducer;
